import { useState } from 'react';
import { Trans } from '@lingui/macro';
import { ActionIcon, Box, LoadingOverlay } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { useTypedSearchParams } from 'react-router-typesafe-routes/dom';
import { ArrowLeft } from 'tabler-icons-react';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import { apiClient } from '../../core/libs/api';
import { HttpResource } from '../../core/libs/http-resource';
import { AddFeedbackForm } from '../../domains/feedback/add-feedback-form';
import { AppNotify } from '../../features/app-notify/app-notify';
import { MainSideMenu } from '../../features/main-side-menu/main-side-menu';
import { routePushNotifyRate } from '../../router/routes';
import {
  addNoAuthFeedbackRequest,
  NewNoAuthFeedback,
} from './add-feedback-no-auth.request';

import styles from './push-notify-rate-trip.page.module.css';

const checkRequiredParams = (searchParams: {
  hash?: string;
  orderId?: number;
}): searchParams is { hash: string; orderId: number } =>
  typeof searchParams.hash === 'string' &&
  typeof searchParams.orderId === 'number';

export const PushNotifyRateTripPage = observer(() => {
  const navigate = useNavigate();
  const [searchParams] = useTypedSearchParams(routePushNotifyRate);

  const hasRequiredParams = checkRequiredParams(searchParams);

  const [addFeedbackRequest] = useState(
    () =>
      new HttpResource<{ hash: string; feedback: NewNoAuthFeedback }, any>({
        apiClient,
        httpRequest: addNoAuthFeedbackRequest,
        errorNotify: new AppNotify(),
        onFinish() {
          // window.location.assign('/');
        },
      })
  );

  const handleSubmit = (feedback: { rating: number; message?: string }) => {
    if (!hasRequiredParams) return;

    addFeedbackRequest.send({
      hash: searchParams.hash,
      feedback: {
        orderId: searchParams.orderId,
        rating: feedback.rating,
        description: feedback.message,
      },
    });
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.backButton}>
          <ActionIcon
            variant="transparent"
            radius="50%"
            size="40px"
            bg="transparent"
            onClick={() => navigate('/')}
          >
            <ArrowLeft size={24} strokeWidth={2} color="white" />
          </ActionIcon>
        </div>

        <div className={styles.routeTitle}>
          <h1 className={styles.headerTitle}>
            <Trans>Оцените поездку</Trans>
          </h1>
        </div>
        <div className={styles.mainSideMenu}>
          <MainSideMenu />
        </div>
      </header>

      <main className={styles.main}>
        <UiCard>
          <Box pos="relative">
            {!hasRequiredParams && (
              <Trans>
                Отсутствуют необходимые параметры в адресе страницы. Оцените
                поездку в приложении
              </Trans>
            )}

            <AddFeedbackForm
              onSubmit={handleSubmit}
              disabled={!hasRequiredParams}
            />
            <LoadingOverlay visible={addFeedbackRequest.isLoading} />
          </Box>
        </UiCard>
      </main>
    </div>
  );
});
